var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiverr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.178 127.475V78.9981H81.7011V75.9731C81.7011 70.9606 85.7732 66.8788 90.7955 66.8788H99.8801V48.6998H90.7955C83.5645 48.7075 76.6319 51.5834 71.5188 56.6965C66.4058 61.8096 63.5299 68.7422 63.5222 75.9731V78.9981H51.4028V97.1771H63.5222V127.475H51.4028V145.654H93.8204V127.475H81.7011V97.1771H112.174V127.475H99.8801V145.654H142.298V127.475H130.178Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.242 67.5965C125.602 67.5965 129.947 63.2513 129.947 57.8913C129.947 52.5313 125.602 48.1862 120.242 48.1862C114.882 48.1862 110.537 52.5313 110.537 57.8913C110.537 63.2513 114.882 67.5965 120.242 67.5965Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7818 19.3909C33.639 19.3909 28.7069 21.4339 25.0704 25.0704C21.4339 28.7069 19.3909 33.639 19.3909 38.7818V155.127C19.3909 160.27 21.4339 165.202 25.0704 168.839C28.7069 172.475 33.639 174.518 38.7818 174.518H155.127C160.27 174.518 165.202 172.475 168.839 168.839C172.475 165.202 174.518 160.27 174.518 155.127V38.7818C174.518 33.639 172.475 28.7069 168.839 25.0704C165.202 21.4339 160.27 19.3909 155.127 19.3909H38.7818ZM38.7818 0H155.127C165.413 0 175.277 4.08593 182.55 11.3589C189.823 18.6319 193.909 28.4962 193.909 38.7818V155.127C193.909 165.413 189.823 175.277 182.55 182.55C175.277 189.823 165.413 193.909 155.127 193.909H38.7818C28.4962 193.909 18.6319 189.823 11.3589 182.55C4.08593 175.277 0 165.413 0 155.127V38.7818C0 28.4962 4.08593 18.6319 11.3589 11.3589C18.6319 4.08593 28.4962 0 38.7818 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiverr);
export default __webpack_public_path__ + "static/media/fiverr.3f91cdd916822f3005bce8f34c26c7f1.svg";
export { ForwardRef as ReactComponent };